import { FC } from 'react'
import { Button } from 'components/extend/Button'
import { COOKIE_AGREEMENT_DOC, PRIVACY_POLICY_PERSONAL_DATA_DOC } from 'constants/docs'

import { ICookieBannerProps } from './types'

export const CookieBanner: FC<ICookieBannerProps> = ({ handleClick }) => (
  <div
    className="fixed bottom-1 z-notice flex w-full p-1 text-inverse-on-surface md:bottom-4 md:justify-center md:p-0"
    // Атрибут data-test="notification" необходим для корректного закрытия нотификации относительно модалок
    data-test="notification"
    data-test-id="cookie--banner"
  >
    <div className="flex w-[260px] flex-col items-center gap-4 rounded-lg bg-inverse-surface p-2 md:w-max md:flex-row">
      <div className="pr-10">
        Мы используем cookie для улучшения работы сервиса.{' '}
        <a
          className="decoration-none border-b border-solid border-inverse-on-surface/[.30] text-inverse-on-surface hover:border-inverse-on-surface focus:border-inverse-on-surface"
          href={PRIVACY_POLICY_PERSONAL_DATA_DOC}
          rel="noreferrer"
          target="_blank"
        >
          Подробнее
        </a>
      </div>
      <div className="w-full md:w-max">
        <Button appearance="primary" className="w-full" onClick={handleClick} size="nm">
          ОК
        </Button>
      </div>
    </div>
  </div>
)
